export class Localisation {
    public static LANG = {
        "English" : 0,
        "spanish": 1,
        "french" : 2,
    };
    
    public static TEXTS = {
        GAME_TAP_TO_DROP_TEXT: ["Tap to drop", "Tocar para soltar", "Taper pour laisser tomber"],
        GAME_PLAY_AN_AD_TO_CONTINUE_TEXT: ["Watch an Ad to continue", "Reproducir un anuncio para continuar", "Jouer une publicité à continuer"],
        GAME_SCORE_TEXT: ["Score", "Puntaje", "Score"],
        GAME_BEST_TEXT: ["Best", "Lmejor", "le meilleur"],
        GAME_OVER_TEXT: ["Game Over","¡Fin del juego!", "Fin de la partie !"],
        GAME_YES_TEXT: ["Yes", "Sí", "Oui"],
        GAME_NO_TEXT: ["No", "No", "Non"],
        GAME_PAUSE_TEXT: ["Paused","en pausa","en pause"],
        GAME_POWERUP_STRETCH_TEXT:["STRETCH","ESTIRAMIENTO","ÉTIREMENT"],
        GAME_POWERUP_SLOW_TEXT:["SLOW","LENTA","LENTE"],
        GAME_POWERUP_FREEZE_TEXT:["FREEZE","CONGELA","GEL"],
        MENU_META_EQUIP_LABEL:["Equip","Equipar","Équiper"],
        MENU_META_SELECTED_LABEL:["Selected","Elegido","Choisi"],
        MENU_META_BUY_LABEL:["Buy","Comprar","Achat"],
    };

}